import { Col, Container, Row } from 'react-bootstrap'
import './Hero.css'
import heroImage from '../../assets/images/hero.svg'
import HeroBox from '../HeroBox/HeroBox'
import { FaUserAlt, FaCode } from "react-icons/fa";
import { MdArticle } from "react-icons/md"
import { ImBook } from 'react-icons/im';
import { BsFillSkipEndFill } from 'react-icons/bs';
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useEffect } from 'react';

function Hero() {
    // we inisialiaze AOS package here for give animation to our web page
    useEffect( () => {
        AOS.init()
    } , [])


    return (
        <>
            <div className="heroContainer">
                <Container>
                    <Row className='align-items-center'>
                        {/* left side picture section : */}
                        {/* we use AOS package for animate  */}
                        <Col className='col-12 col-md-6' data-aos="zoom-in" data-aos-duration="900">
                            <img src={heroImage} className='heroImg img-fluid' alt="heroPic" />
                        </Col>

                        {/* right side Statistics section :*/}
                        <Col className='col-12 col-md-6' data-aos="zoom-in" data-aos-duration="900">
                            <h2 className="heroTitle vidalokaFont">Statistics make us proud😎</h2>
                            <Row className='justify-content-center row-cols-1 row-cols-xl-2 gy-4'>
                                {/* Column of numbers for ex: Number of students and ... */}
                                {/* we use hero box component here */}

                        {/* we use Countup component for Counting numbers of heroBox  */}

                                {/* first : number of student */}
                                <Col>
                                    <HeroBox title='Number of students' count={3500}>
                                        <FaUserAlt size='40px' />
                                    </HeroBox>
                                </Col>
                                {/* second : number of articles */}
                                <Col>
                                    <HeroBox title='Number of articles' count={995}>
                                        <MdArticle size='40px' />
                                    </HeroBox>
                                </Col>
                                {/* third : number of courses */}
                                <Col>
                                    <HeroBox title='Number of courses' count={18}>
                                        <ImBook size='40px' />
                                    </HeroBox>
                                </Col>
                                {/* forth : Successful project  */}
                                <Col>
                                    <HeroBox title='Successful project' count={14}>
                                        <FaCode size='40px' />
                                    </HeroBox>
                                </Col>
                            </Row>
                            <p className="startLearing">
                                <b>Start Training</b>
                                <BsFillSkipEndFill className='icon-logo' size='40px' />
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#d2d2d2ff" fillOpacity="1" d="M0,320L30,272C60,224,120,128,180,112C240,96,300,160,360,202.7C420,245,480,267,540,240C600,213,660,139,720,138.7C780,139,840,213,900,218.7C960,224,1020,160,1080,117.3C1140,75,1200,53,1260,58.7C1320,64,1380,96,1410,112L1440,128L1440,0L1410,0C1380,0,1320,0,1260,0C1200,0,1140,0,1080,0C1020,0,960,0,900,0C840,0,780,0,720,0C660,0,600,0,540,0C480,0,420,0,360,0C300,0,240,0,180,0C120,0,60,0,30,0L0,0Z"></path></svg>
        </>
    )
}

export default Hero